import { IUser, UserStatus } from 'api-paths-cas';
import { IOption } from 'shared-components';
import { ActionSelection } from '../../../types';
import { hasPerm, P } from '@/utilities/roles/permissions';
import { UserRole } from '@/store/auth/types';

export const getManagePasswordOptions = (userRole: UserRole, studentUserRecord: IUser | null): Array<IOption> => {
  const options: Array<IOption> = [];

  if (hasPerm(userRole, P.RESEND_RESET_PASSWORD) && studentUserRecord !== null) {
    const isResetPassword = studentUserRecord?.status === UserStatus.CONFIRMED;

    const label = isResetPassword ? 'Reset password' : 'Resend invitation';
    const value = isResetPassword ? ActionSelection.RESET_PASSWORD : ActionSelection.RESEND_INVITE;

    options.push({
      label,
      value,
    });
  }

  return options;
};
